export const getHeaderId = (id?: string) => {
	return id ? `${id}-header` : '';
};
